import React, { useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiX } from 'react-icons/fi';

const TrailerModal = ({ videoKey, onClose, onProgress, startAt = 0 }) => {
  const iframeRef = useRef();
  const timerRef  = useRef();

  // Poll YouTube iframe API for time updates
  useEffect(() => {
    if (!videoKey || !onProgress) return;
    // postMessage polling every 5 s — full iframe API requires same-origin
    // We use a lightweight interval-based approach
    timerRef.current = setInterval(() => {
      try {
        iframeRef.current?.contentWindow?.postMessage(
          '{"event":"listening","id":1}', '*'
        );
      } catch (_) {}
    }, 5000);
    return () => clearInterval(timerRef.current);
  }, [videoKey, onProgress]);

  useEffect(() => {
    if (!onProgress) return;
    const handler = (e) => {
      try {
        const d = JSON.parse(e.data);
        if (d.event === 'infoDelivery' && d.info?.currentTime) {
          onProgress(Math.floor(d.info.currentTime));
        }
      } catch (_) {}
    };
    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }, [onProgress]);

  const src = videoKey
    ? `https://www.youtube.com/embed/${videoKey}?autoplay=1&rel=0&modestbranding=1&enablejsapi=1${startAt > 30 ? `&start=${Math.floor(startAt)}` : ''}`
    : null;

  return (
    <AnimatePresence>
      {videoKey && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          onClick={onClose}
          className="fixed inset-0 z-50 flex items-center justify-center p-4 md:p-10"
          style={{ background: 'rgba(0,0,0,0.93)', backdropFilter: 'blur(14px)' }}>
          <motion.div
            initial={{ scale: 0.82, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.82, opacity: 0 }}
            transition={{ type: 'spring', stiffness: 280, damping: 26 }}
            onClick={e => e.stopPropagation()}
            className="relative w-full max-w-5xl rounded-2xl overflow-hidden"
            style={{
              border: '1px solid rgba(229,9,20,0.3)',
              boxShadow: '0 0 80px rgba(229,9,20,0.18), 0 40px 80px rgba(0,0,0,0.8)',
              aspectRatio: '16/9',
            }}>
            <iframe ref={iframeRef} src={src}
              allow="autoplay; encrypted-media; fullscreen"
              allowFullScreen className="w-full h-full" title="Player"
              style={{ border: 'none' }} />
            <motion.button whileHover={{ scale: 1.1, rotate: 90 }} whileTap={{ scale: 0.9 }}
              onClick={onClose}
              className="absolute top-3 right-3 w-9 h-9 rounded-full glass flex items-center justify-center"
              style={{ color: 'var(--text)', zIndex: 10 }}>
              <FiX size={18} />
            </motion.button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default TrailerModal;
